import './styles/QuickActionItem.css';

interface QuickActionItemProps {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  badge?: string;
  disabled?: boolean;
}

const QuickActionItem: React.FC<QuickActionItemProps> = ({ icon, label, onClick, badge, disabled }) => (
  <button className={`quick-action${disabled ? ' quick-action--disabled' : ''}`} onClick={disabled ? undefined : onClick} disabled={disabled}>
    <span className="quick-action__icon">{icon}</span>
    <span className="quick-action__label">{label}</span>
    {badge ? <span className="quick-action__badge">{badge}</span> : <span className="quick-action__arrow">→</span>}
  </button>
);

export default QuickActionItem;
